import { render, staticRenderFns } from "./mySelect.vue?vue&type=template&id=fa3ddcc0&"
import script from "./mySelect.vue?vue&type=script&lang=js&"
export * from "./mySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports